export default class Attribute {
  key: string
  value: string

  constructor(data: any) {
    this.key = data.key
    this.value = data.value
  }
}
